import { forwardRef } from "react";
import phoneLogo from "../../assets/telephone.png";
import emailLogo from "../../assets/email.png";
import sipparLogo from "../../assets/sippar-logo.svg";

const SipparLightsInvoiceTemplate = forwardRef(({ invoiceData }, ref) => {
  // STATIC INFORMATION
  const sipparEmail = "sipartrades@gmail.com";
  const sipparPhone1 = "+46736231790";
  const sipparPhone2 = "+9647709473196";

  return (
    <div
      ref={ref}
      className="o-column u-height_screen-height only-print"
      dir="ltr"
    >
      {/* HEADER */}
      <div>
        {/* TOP GREEN BAR */}
        <div className="sippar-top-bar"></div>

        {/* HEADER & LOGO */}
        <div className="o-row o-row--vertical-align_start o-row--horizontal-align_space-between u-width_full-width">
          {/* LOGO */}
          <div className="o-row o-row--horizontal-align_center o-row--vertical-align_center sippar-logo">
            <img src={sipparLogo} alt="Company Logo" />
          </div>

          {/* HEADER */}
          <div className="o-column t-text-align_center u-padding--top_400 ">
            <h1 className="u-margin_0 u-padding_0 sippar-title">
              {"Sippar Lights"}
            </h1>
            <p className="u-margin_0 u-padding_0 sippar-subtitle">
              {"Trading and Services"}
            </p>
          </div>

          <div className="u-width-specific_120"></div>
        </div>
      </div>

      {/* BODY */}
      <div className="o-column o-column--horizontal-align_space-between u-padding--right_700 u-padding--left_700 u-height_full-height">
        {/* DELIVERY */}
        <div>
          <div className="o-row o-row--horizontal-align_space-between o-row--vertical-align_end u-margin--bottom_700">
            {/* Seller Info */}
            <div className="o-column u-margin_0 u-padding_0">
              <h3 className="t-bold_bold t-text-medium u-margin_0 u-padding_0 sippar-primary-color">
                SIPPAR LIGHTS
              </h3>
              <p className="t-text-medium u-margin_0 u-padding_0 sippar-primary-color">
                IRAQ - BAGHDAD
              </p>
            </div>

            {/* Delivery & Date */}
            <div className="o-column t-text-align_start ">
              <h2 className="sippar-delivery">Delivery Notes</h2>
              <div className="o-column u-margin_0 u-padding_0">
                <p className="t-text-medium u-margin_0 sippar-primary-color">
                  {new Date(invoiceData?.date).toLocaleDateString("en-us", {
                    weekday: "long",
                  }) || "---"}
                </p>
                <p className="t-text-medium u-margin_0 sippar-primary-color">
                  DATE: {invoiceData?.date}
                </p>
                <p className="t-text-medium t-bold_bold sippar-green-color">
                  INVOICE NO.: {invoiceData?.invoiceNumber || "000044"}
                </p>
              </div>

              {/* Buyer Info */}
              <div className="o-column t-text-align_start u-padding_0">
                <h3 className="t-bold_bold t-text-medium u-margin_0 u-padding_0 sippar-primary-color">
                  {invoiceData?.buyerName || "CUSTOMER NAME..."}
                </h3>
                <p className="t-text-medium u-margin_0 u-padding_0 sippar-primary-color">
                  {invoiceData?.buyerLocation || "LOCATION..."}
                </p>
              </div>
            </div>
          </div>

          {/* TABLE */}
          <table className="u-margin--bottom_700 sippar-table">
            <thead className="sippar-green-background u-width_full-width sippar-table-head">
              <tr>
                <th className="u-padding_400 t-bold_bold t-text-medium t-text-align_start">
                  Desc.
                </th>
                <th className="u-padding_400 t-bold_bold t-text-medium t-text-align_center">
                  Quantity
                </th>
                <th className="u-padding_400 t-bold_bold t-text-medium t-text-align_center">
                  Price Per Ton
                </th>
                <th className="u-padding_400 t-bold_bold t-text-medium t-text-align_center">
                  Price
                </th>
              </tr>
            </thead>
            <tbody className="t-text-align_center">
              {invoiceData?.items && invoiceData.items.length > 0
                ? invoiceData.items.map((item, index) => (
                    <tr
                      key={index}
                      className={
                        index % 2 === 0
                          ? "sippar-table-row-even"
                          : "sippar-table-row-odd"
                      }
                    >
                      <td className="u-padding_400 t-text-medium t-text-align_start sippar-table-cell">
                        {item.description}
                      </td>
                      <td className="u-padding_400 t-text-medium sippar-table-cell">
                        {item.quantity}
                      </td>
                      <td className="u-padding_400 t-text-medium sippar-table-cell">
                        ${item.pricePerTon?.toFixed(2) || "0.00"}
                      </td>
                      <td className="u-padding_400 t-text-medium t-text-align_center sippar-table-cell">
                        ${item.totalPrice?.toFixed(2) || "0.00"}
                      </td>
                    </tr>
                  ))
                : null}
            </tbody>
          </table>
        </div>

        {/* TOTALS SECTION */}
        <div>
          <div className="o-row o-row--horizontal-align_space-between">
            {/* TOTAL PRICE & DISCOUNT */}
            <div className="o-column o-column--horizontal-align_space-between u-min-width-specific_200 sippar-totals-box">
              {/* TOTAL PRICE */}
              <div className="o-row o-row--vertical-align_center u-padding--left_400 u-min-width-specific_150 sippar-totals-row">
                <p className="t-bold_bold u-min-width-specific_100 sippar-totals-label">
                  TOTAL PRICE:
                </p>
                <p className="t-text-standard t-bold_bold sippar-totals-value">
                  ${invoiceData?.totalPrice?.toFixed(2) || "--"}
                </p>
              </div>

              {/* DISCOUNT */}
              <div className="o-row o-row--vertical-align_center o-row--gap-size_200 u-padding--left_400 u-min-width-specific_100">
                <div className="t-bold_bold u-min-width-specific_100 sippar-totals-label">
                  DISCOUNT:
                </div>
                <div className="t-text-standard t-bold_bold sippar-totals-value">
                  {invoiceData?.discountPercentage
                    ? `${invoiceData?.discountPercentage} %`
                    : "none"}
                </div>
              </div>
            </div>

            {/* TOTAL TONS & FINAL PRICE */}
            <div className="o-column o-column--horizontal-align_space-between t-text-align_center u-min-width-specific_200 sippar-totals-box">
              <div className="o-row o-row--vertical-align_center o-row--gap-size_200 u-padding_100 sippar-totals-row">
                {/* TOTAL TONS */}
                <div className="t-text-standard t-bold_bold u-min-width-specific_100 sippar-totals-label">
                  TOTAL TONS:
                </div>
                <div className="t-text-standard t-bold_bold sippar-totals-value">
                  {invoiceData?.totalTons || "none"}
                </div>
              </div>
              {/* FINAL PRICE */}
              <div className="o-row o-row--vertical-align_center o-row--gap-size_200 u-padding_100">
                <div className="t-text-standard t-bold_bold u-min-width-specific_100 sippar-totals-label">
                  FINAL PRICE:
                </div>
                <div className="t-text-standard t-bold_bold sippar-totals-value">
                  ${parseFloat(invoiceData?.finalPrice).toFixed(2) || "none"}
                </div>
              </div>
            </div>
          </div>
          <div className="t-text-align_center t-bold_bold u-margin_700 sippar-thank-you">
            Thank you for your business
          </div>
        </div>
      </div>

      {/* footer and contact information */}
      <div className="o-column o-column--gap-size_500 sippar-footer">
        {/* contact information */}
        <div className="o-row o-row--horizontal-align_space-between o-row--gap-size_200 u-padding--right_700 u-padding--left_700 u-padding--top_200">
          {/* EMAIL */}
          <div className="o-row o-row--vertical-align_center o-row--gap-size_200">
            <div>
              <img src={emailLogo} className="u-height-specific_20" />
            </div>
            <div>
              <p>{sipparEmail}</p>
            </div>
          </div>

          {/* PHONE 1 */}
          <div className="o-row o-row--vertical-align_center o-row--gap-size_200 ">
            <div>
              <img src={phoneLogo} className="u-height-specific_20" />
            </div>
            <div>
              <p>{sipparPhone1}</p>
            </div>
          </div>

          {/* PHONE 2 */}
          <div className="o-row o-row--vertical-align_center o-row--gap-size_200 ">
            <div>
              <img src={phoneLogo} className="u-height-specific_20" />
            </div>
            <div>
              <p>{sipparPhone2}</p>
            </div>
          </div>
        </div>

        {/* Al-habbar slogan */}
        <div className="o-column t-text-align_center t-text-medium t-bold_semi-bold habbar-slogan">
          <div>Ehsibly For Management And Accounting</div>
          <div>Made By Al-Habbar Technologies</div>
        </div>
      </div>
    </div>
  );
});

export default SipparLightsInvoiceTemplate;
